/**
 * useRenameVideo — updates the `label` field on a `criativos` row
 * scoped to the current user.
 *
 * The Videos page uses the `criativos` table (creative analysis), so this
 * hook mirrors the pattern of useDeleteCriativo used on the same page.
 */
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useSupabaseClient } from "@/lib/supabase";
import { useProfileId } from "@/features/onboarding/hooks/useProfileId";

interface RenameVideoInput {
  id: string;
  label: string;
}

export function useRenameVideo() {
  const qc = useQueryClient();
  const { client } = useSupabaseClient();
  const { profileId } = useProfileId();

  return useMutation<void, Error, RenameVideoInput>({
    mutationFn: async ({ id, label }) => {
      if (!profileId) throw new Error("Sessão não pronta. Tente novamente.");
      const { error } = await client
        .from("criativos")
        .update({ label })
        .eq("id", id)
        .eq("user_id", profileId);
      if (error) throw new Error(error.message);
    },
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ["criativos"] });
    },
  });
}
